<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-form @submit.prevent="handleSubmit">
        <v-card-title>
          Insucesso ao agendar
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-alert v-if="errorMessage" type="error">
            {{ errorMessage }}
          </v-alert>
          <div class="mb-4">Tentativa de contacto</div>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.date"
                :error-messages="errors.date"
                type="date"
                label="Data"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.time"
                :error-messages="errors.time"
                type="time"
                label="Hora"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-radio-group
            v-model="form.successful_contact"
            :error-messages="errors.successful_contact"
            label="Foi possível contactar?"
            dense
          >
            <v-radio label="Sim" :value="true"></v-radio>
            <v-radio label="Não" :value="false"></v-radio>
          </v-radio-group>

          <div v-if="form.successful_contact === true">
            <v-radio-group
              v-model="form.participant_refused"
              :error-messages="errors.participant_refused"
              label="O cliente aceitou os serviços?"
              dense
            >
              <v-radio :value="false">
                <template #label> Aceitou </template>
              </v-radio>
              <v-radio :value="true">
                <template #label> Recusou </template>
              </v-radio>
            </v-radio-group>
          </div>

          <div class="mt-4">
            <v-autocomplete
              v-model="form.justification_id"
              :error-messages="errors.justification_id"
              label="Justificativa"
              outlined
              dense
              :items="justifications"
              :loading="loadingJustifications"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text>Cancelar</v-btn>
          <v-btn color="primary" :loading="submiting" type="submit">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { showCategory } from "@/services/form_options";
import { formatDateForInput, formatTimeForInput } from "@/tools/date";
import { storeFailureToSchedule } from "@/services/lead_schedules";

export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      dialog: false,
      schedulingId: null,

      form: {},
      errors: {},
      errorMessage: "",
      submiting: false,

      justifications: [],
      loadingJustifications: false,
    };
  },

  methods: {
    open(schedulingId) {
      this.dialog = true;
      this.schedulingId = schedulingId;

      this.form = {
        date: formatDateForInput(Date.now()),
        time: formatTimeForInput(Date.now()),
      };
    },
    close() {
      this.dialog = false;
    },
    async loadJustifications(categoryId) {
      this.loadingJustifications = true;
      this.justifications = [];

      try {
        const { data } = await showCategory(categoryId);
        this.justifications = data.data.options;
        if (data.data.options.length === 1) {
          this.form.justification_id = data.data.options[0].id;
        }
      } finally {
        this.loadingJustifications = false;
      }
    },
    async handleSubmit() {
      this.submiting = true;
      this.errorMessage = "";
      this.errors = {};

      try {
        const { data } = await storeFailureToSchedule(
          this.schedulingId,
          this.form
        );
        this.$emit("saved", data.data);
        this.close();
      } catch (error) {
        if (error.response.status === 400) {
          this.errorMessage = error.response.data.message;
          return;
        }

        if (error.response.status === 422) {
          this.errorMessage = error.response.data.message;
          this.errors = error.response.data.errors;
          return;
        }
      } finally {
        this.submiting = false;
      }
    },
  },

  watch: {
    "form.successful_contact": {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue !== false) {
          this.loadJustifications("FAILED_CONTACT_ATTEMPT_JUSTIFICATIONS");
        }
      },
      deep: true,
    },
    "form.participant_refused": {
      handler(newValue, oldValue) {
        if (newValue === false) {
          this.loadJustifications("SUCCESSFUL_CONTACT_ATTEMPT_JUSTIFICATIONS");
          return;
        }

        if (newValue === true) {
          this.loadJustifications("SCHEDULING_REFUSE_JUSTIFICATIONS");
          return;
        }
      },
      deep: true,
    },
  },

  computed: {},
};
</script>
